import React from 'react';
import Header from './Header';
import Footer from './Footer';
import GetStartedModal from '../common/GetStartedModal';
import ConsultationPopup from '../common/ConsultationPopup';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main id="main-content" className="flex-grow pt-16"> {/* pt-16 accounts for fixed header */}
        {children}
      </main>
      <Footer />
      <GetStartedModal />
      <ConsultationPopup />
    </div>
  );
};

export default Layout;
